import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as why from "./style.module.scss";
export const Why = ({ accessLimited }) => {
  return (
    <section className={main.sec}>
      <div className="container">
        <div className={main.blockTitle}>
          Почему выбирают нас?
        </div>
        <div className={`row ${why.why_row}`}>
          <div className={`col col-4 ${why.why_col}`}>
            <div className={why.why_colIcon}>
              <img src="https://fs.advance.ru/landing-pages/online/globus/pict5.svg" alt=""/>
            </div>
            <div className={why.why_colName}>
              Более 75&nbsp;000&nbsp;учащихся
            </div>
            <div className={why.why_colDesc}>
              Доверяют нам&nbsp;повышение <br/>
              своей эффективности <br/>
              и&nbsp;интеллектуальной выносливости
            </div>
          </div>
          <div className={`col col-4 ${why.why_col}`}>
            <div className={why.why_colIcon}>
              <img src="https://fs.advance.ru/landing-pages/online/globus/pict6.svg" alt=""/>
            </div>
            <div className={why.why_colName}>
              Более 10&nbsp;лет практики
            </div>
            <div className={why.why_colDesc}>
              В&nbsp;разработке технологий <br/>
              личной эффективности человека
            </div>
          </div>
          <div className={`col col-4 ${why.why_col}`}>
            <div className={why.why_colIcon}>
              <img src="https://fs.advance.ru/landing-pages/online/globus/pict7.svg" alt=""/>
            </div>
            <div className={why.why_colName}>
              Научный метод
            </div>
            <div className={why.why_colDesc}>
              Используем технологии <br/>
              работы с&nbsp;информацией, <br/>
              проверенные временем
            </div>
          </div>
        </div>
        <div className={main.btnBlock}>
          <a className={main.mainBtn} href="#cost">
            Хочу на курс
          </a>
        </div>
        { accessLimited && <p style={{ margin: "30px 0 0", textAlign: "center" }}>Бесплатный доступ действителен в&nbsp;течение 7&nbsp;дней</p> }
      </div>
    </section>
  );
};
